import _ from 'lodash';
import React, { Component } from 'react';

import {
  focusAfterTimeout,
} from '../../util';

import { importUser } from '../../actions/users';

class ImportUserModal extends Component{

  state = {
    error: null,
    message: null,
    importing: false,
    emailOfUserToImport: 'prbaylog+demoassessmentnewscoringtest2@gmail.com',//null
  }

  componentWillMount(){
    focusAfterTimeout(this, 'emailInput');
  }
  // componentDidUpdate(prevProps){
  //   console.log('prevProps: ', prevProps);
  //   if(!prevProps){
  //     focusAfterTimeout(this, 'emailInput');
  //   }
  // }

  importUser(user){
    if(this.state.importing){
      return;
    }

    this.setState({ importing: true });

    importUser(this.state.emailOfUserToImport, result => {
      console.log('result: ', result);
      if(result && result.user){
        this.setState({ importing: false });
      }
      else{
        this.setState({
          importing: false,
          error: result.error,
        });
      }
    })
  }

  renderFormMessage(){
    if(this.state.error){
      return <div className="form-message error">{this.state.error}</div>;
    }
    else if(this.state.message){
      return <div className="form-message success">{this.state.message}</div>;
    }
    else{
      return <div className="form-message placeholder">&nbsp;</div>;
    }
  }

  renderImportForm(){
    return (
      <form className="velocity-form">
        {this.renderFormMessage()}
        <div className="form-group">
          <div className="input-group full-width">
            <label htmlFor="velocity-email">User's Email</label>
            <input ref={input => { this.emailInput = input; }} id="velocity-email" type="text" value={this.state.emailOfUserToImport} onChange={e => { this.setState({ emailOfUserToImport: e.target.value }); }} />
          </div>
        </div>
      </form>
    )
  }

  render(){

    const {
      importing
    } = this.state;

    return (
      <div className="modal">
        <div className="modal-container">
          <div className="close-icon" onClick={this.props.hide}>X</div>
          <div className="modal-content">
            <h2>Import Public User</h2>
            <p>Imported users are given the "seller" role by default. This can be updated after importing.</p>
            {this.renderImportForm()}
          </div>
          <div className="modal-actions">
            <button onClick={this.importUser.bind(this)} disabled={this.state.importing} className="button primary">Import</button>
          </div>
        </div>
      </div>
    )
  }
}

export default ImportUserModal;



// WEBPACK FOOTER //
// ./src/components/modals/importUser.js